import * as CAMDashboardActionTypes from '../actionTypes/CAMDashboardActionTypes';
import { PROMOTIONAL_ANALYTICS_ACTION } from '../actionTypes/CAMDashboardActionTypes';

export const camAnalyticsAction = (data) => ({
    type: CAMDashboardActionTypes.CAM_PAGE_ANALYTICS_ACTION,
    payload: data,
});

export const promotionalAnalyticsAction = (data) => ({
    type: PROMOTIONAL_ANALYTICS_ACTION,
    payload: data,
});

export default camAnalyticsAction;
